import { CircularProgress, alpha } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useSpinnerStyles = makeStyles(theme => ({
    backdrop: {
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.standard,
        }),
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: theme.zIndex.modal,
        background: alpha(theme.palette.background.default, 0.5),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
}));
export function FullscreenSpinner(props: { loading: boolean }) {
    const classes = useSpinnerStyles();
    return (
        <div
            className={classes.backdrop}
            style={{
                opacity: props.loading ? 1 : 0,
                pointerEvents: props.loading ? 'all' : 'none',
            }}>
            <CircularProgress />
        </div>
    );
}